var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallerySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.11 1.89v12.22H1.89V1.89h12.22m0-1.75H1.89C.93.14.14.93.14 1.89v12.22c0 .96.79 1.75 1.75 1.75h12.22c.96 0 1.75-.79 1.75-1.75V1.89c0-.96-.79-1.75-1.75-1.75zM9.87 7.88L7.25 11.254 5.379 8.996l-2.617 3.371h10.476zm0 0",
    fill: "#232323"
  })));
}
export default SvgGallerySmall;